import {FaCocktail, FaHiking, FaShuttleVan, FaBeer} from 'react-icons/fa'


const data =  [
    {
        id:1,
        icon:<FaCocktail/>,
        title:"Free cocktails",
        info: "this is just a dummy info for all the services for now because i will be adding more later in the day",
    },
    {
        id:2,
        icon:<FaHiking/>,
        title:"Endless Hiking",
        info: "this is just a dummy info for all the services for now because i will be adding more later in the day",
    },
    {
        id:3,
        icon:<FaShuttleVan/>,
        title:"Free Shuttle",
        info: "this is just a dummy info for all the services for now because i will be adding more later in the day",
    },
    {
        id:4,
        icon:<FaBeer/>,
        title:"Strongest Beer",
        info: "this is just a dummy info for all the services for now because i will be adding more later in the day",
    },
]

export default data